import { APIProvider } from "@vis.gl/react-google-maps";
import { VStack } from "apps/commons/components/Stack";
import { scrollToTop } from "apps/commons/functions/scrollToTop";
import { locationBinder } from "libs/analytics/binders/onboarding/location";
import { useAnalytics } from "libs/analytics/useAnalytics";
import { useEffect } from "react";
import { Title } from "../Title";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { ManualLocationController } from "./ManualLocationController";
import { MapController } from "./MapController";
import { MapSearchController } from "./search/MapSearchController";

export const LocationPage = () => {
    const {
        cmsData: {
            location: { location },
        },
    } = useStaticDataAtomValue();

    useEffect(() => {
        scrollToTop();
    }, []);

    useAnalytics(locationBinder);

    return (
        <APIProvider apiKey="AIzaSyAZV7lkT1hquxMCaWRzrPFwf93HPIszv_s" libraries={["places"]}>
            <VStack gap="24" pb="32">
                <Title title={location} />
                <VStack gap="16">
                    <MapSearchController />
                    <ManualLocationController />
                </VStack>
                <MapController />
            </VStack>
        </APIProvider>
    );
};
